module.exports = __webpack_public_path__ + "static/media/chatIcon-no-bg.ad6b1db4.png";